export default __webpack_public_path__ + "static/media/small.1648d72b.jpg";